import { render, staticRenderFns } from "./CategoriesView.vue?vue&type=template&id=538cea7a&scoped=true&"
import script from "./CategoriesView.vue?vue&type=script&lang=js&"
export * from "./CategoriesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538cea7a",
  null
  
)

export default component.exports